import { sortBy } from 'lodash';

import { isHierarchicalItem } from 'src/lib/hierarchy';
import { nameWithAncestry } from 'src/presentation/components/pages/topics/hierarchy';
import topicsResource, { Topic } from 'src/actions/topics/topicsResource';
import { useResourceValues } from 'src/presentation/hooks/useResource';

export default function useTopics() {
  const { dataMergeFinished, values } = useResourceValues(topicsResource);

  const disabledTopics = new Set();
  const topicOptions = sortBy(
    values
      .filter(({ id, disabled }) => {
        if (disabled) disabledTopics.add(id);
        return !disabled;
      })
      .map((topic: Topic) => {
        // fall back on the topic name if the topic hierarchy is not yet loaded
        const label = isHierarchicalItem(topic) ? nameWithAncestry(topic) : topic.name;

        return { label, value: topic.id };
      }),
    ['label']
  );

  const removableOptions = Array.from(disabledTopics).map(id => ({
    label: values.find(topic => topic.id === id).name,
    value: id,
  }));

  return {
    dataMergeFinished,
    disabledTopics,
    topicOptions,
    removableOptions,
  };
}
